import React from "react";
import HeroCard from "@/components/heroCard";
import { TRANSFER_CONSTANTS } from "./constants";

const TransferCta = () => {
  return (
    <HeroCard backgroundImage="/background/banner-bg2.png" {...TRANSFER_CONSTANTS} />
  );
};

export default TransferCta;
